module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/3954a4b8029afa558b84c060f7bb00ef.png";